import posthog from 'posthog-js';
import { browser, version } from '$app/environment';

const isProduction = import.meta.env.MODE === 'production';

export const posthogEnabled = isProduction;

const posthogKey = isProduction
	? 'phc_rB8d8kiQ7YEhotU36cjrgqi8WfcjpPJWYrkcg4qTjN9N'
	: 'phc_my4Mz638ksoJPGx4BkCZvJxgzabr4iBZdL3ADXYUqZxk';

export function initPostHog() {
	if (!browser || !posthogEnabled) return;

	posthog.init(posthogKey, {
		api_host: 'https://us.i.posthog.com',
		defaults: '2026-01-30',
		loaded: () => {
			posthog.register({ app_version: version });
		}
	});
}
